import { render, staticRenderFns } from "./IconSvgXlsx.vue?vue&type=template&id=9f6e4018&scoped=true&"
import script from "./IconSvgXlsx.vue?vue&type=script&lang=js&"
export * from "./IconSvgXlsx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6e4018",
  null
  
)

export default component.exports